import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import HTTP from '../../../script/service';
import { Tabs } from 'antd';
import Util from '../../../script/util';
import { DDEmpty, DDLoading } from '../../globalPageStatus';
import './Song.scss';
import Scrollbar from 'react-scrollbars-custom';
import iconMySongEmptyPNG from '../img/my-song-empty.png';

class Song extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      songList: [],
      songItemList: [],
      sheetId: null,
    };
  }
  componentDidMount() {
    this.getSongList();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }
  //获取歌单
  getSongList = () => {
    this.setState({ loading: true }, () => {
      HTTP._get_song_list({
        targetUid: this.props.uid,
      })
        .then((res) => {
          if (res?.code === 200) {
            this.setState({ songList: res.data.list || [] }, () => {
              const { songList } = this.state;
              this.setState({
                sheetId: songList[0]?.sheetId,
              });
              this.getSongItemList(songList[0]?.sheetId);
            });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    });
  };

  //获取歌曲
  getSongItemList = (sheetId = this.state.sheetId) => {
    if (!sheetId) {
      this.setState({ loading: false });
      return;
    }
    this.setState({ loading: true }, () => {
      HTTP._get_song_item({
        sheetId: sheetId,
        targetUid: this.props.uid,
      })
        .then((res) => {
          if (res?.code === 200) {
            this.setState({ songItemList: res.data.list || [] });
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  // 改变歌单
  onChangeSheetTabs = (key) => {
    this.setState({ sheetId: Number(key), isMoreData: true }, () => {
      this.getSongItemList(this.state.sheetId);
    });
  };
  render() {
    const { loading, songList, songItemList, sheetId } = this.state;
    return (
      <DDLoading status={loading}>
        <div className="ds-song-list-wrap">
          {!!songList.length ? (
            <Tabs className="song-sheet" onChange={this.onChangeSheetTabs}>
              {songList.map((n) => (
                <Tabs.TabPane
                  key={`${n.sheetId}`}
                  tab={
                    <div
                      className={`sheet-item ${sheetId === n.sheetId ? 'active' : ''} `}
                      style={{
                        backgroundImage: `url(${Util.transImgUrl(n.sheetPic, '128x68')})`,
                      }}
                    >
                      <h4 className="sheet-name">{n.sheetName}</h4>
                      <span className="sheet-count">{n.totalSongNum}首</span>
                    </div>
                  }
                />
              ))}
            </Tabs>
          ) : (
            <div className="not-song-list">
              <DDEmpty
                description="暂无歌单~"
                isShowImage={false}
                customImage={iconMySongEmptyPNG}
              />
            </div>
          )}
          {songItemList.length > 0 ? (
            <div className="song-item">
              <Scrollbar>
                {songItemList.map((n, i) => (
                  <div
                    className={`song-item-col ${n.status ? '' : 'down'}`}
                    key={i}
                  >
                    <span>{i + 1}</span>
                    <span>
                      {n.songName}
                      {!n.status ? <i>已下架</i> : ''}
                    </span>
                  </div>
                ))}
              </Scrollbar>
            </div>
          ) : (
            songList.length > 0 && <DDEmpty description="歌单里还没有歌曲哦~" />
          )}
        </div>
      </DDLoading>
    );
  }
}

export default withRouter(Song, { withRef: true });
